module.exports = __webpack_public_path__ + "media/images/background_home-800w-c647829e.jpg";